import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

// Import axios plugin đã được cấu hình
import axios from './plugins/axios'

// Cấu hình baseURL cho axios
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:5000/api'
axios.defaults.headers.common['Content-Type'] = 'application/json'

// Tạo instance của ứng dụng
const app = createApp(App)

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, info)
  store.dispatch('app/showError', 'Có lỗi xảy ra trong ứng dụng')
}

// Cài đặt plugins
app.use(router)
app.use(store)
app.use(vuetify)

// Mount ứng dụng
app.mount('#app')